// Shared Socket Instance
import { io } from 'socket.io-client';

const DEV_URL = 'http://localhost:4001';
const PROD_URL = 'https://call-it-out-server.onrender.com';

// This line automatically chooses the correct URL based on whether its in dev mode or production mode
const URL = process.env.NODE_ENV === 'production' ? PROD_URL : DEV_URL;

export const socket = io(URL, {
    transports: ['websocket'],
    withCredentials: true
});
